<template>
<div class="mt-3">
    <h3 class="text-center print-media">Aggregate Analytical Report</h3>
    <template>
        <div class="form-row print-media">
            <div class="col-sm-12">
                <b-card style="border: 1px dotted #07a7e14f;">
                    <div class="row">
                        <div class="col-sm-6">
                            <label style="font-weight:700;" for="first">Select Subprogramme
                            </label>
                            <selectize id="select-state sub_program" class="text-capitalize " v-model="subprogram" :settings="subProgramSetting" :searchable="true">
                                <option v-for="(item, index) in subprogramsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                    {{ item.title }}
                                </option>
                            </selectize>
                        </div>
                        <div class="col-sm-6">
                            <label style="font-weight:700;" for="first">Select Project
                            </label>
                            <selectize id="select-state sub_program" class="text-capitalize " v-model="project" :settings="projectSetting" :searchable="true">
                                <option v-for="(item, index) in projectsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                    {{ item.title }}
                                </option>
                            </selectize>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <label style="font-weight:700;" for="first">Select Thematic Area
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                            </label>
                            <selectize id="select-state sub_program" class="text-capitalize " v-model="thematicId" :settings="projectSetting" :searchable="true">
                                <option v-for="(item, index) in thematicAreasLoad" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                    {{ item.name }}
                                </option>
                            </selectize>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label style="font-weight:700;" for="first">Date Range <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>

                                <flat-pickr class="form-control" style="background: #fff;opacity:1; height: 34px;" placeholder="Start date Range" v-model="dateRange" :config="dateOptions"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-sm-12 text-right mt-2">
                            <!-- Get Report button -->
                            <b-button class="download-btn" variant="primary" @click="getReport" :disabled="!thematicId || !startDate || !endDate">
                                Get Report
                            </b-button>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
        
    </template>
    <!-- -->
    <template v-if="showGraph == true">
        <div class="row mt-1">
            <div class="col-4">
                <div class="print_logo " style="display:none;" slot="header">
                    <img :src="BASE_PATH+'/unodc_logo.png'" alt="" width="200" />
                </div>
            </div>
            <div class="col-4 mt-6">
                <h5 class="text-blue print_logo" style="display:none;margin-top: 20px;">
                    Thematic Analysis Report
                </h5>
            </div>
            <div class="col-4">
                <h6 class="print_logo mt-1" style="display:none;text-align:justify;  padding-left: 45px">
                    Country Office Pakistan<br />Monitoring & Evaluation Unit
                </h6>
            </div>
        </div>
        <div class="row print-media">
            <div class="col-lg-6">
                <h6 class="text-blue print-title">
                    Thematic Event Information
                </h6>
            </div>
            <div class="col-lg-6">
                <button class="btn btn-primary text-uppercase btn-report float-right ml-3" @click="PrintEvent">
                    Print Aggregate Analysis Report
                    <i class="material-icons" style="font-size: 20px;">print</i>
                </button>
            </div>
        </div>
        <!-- Summary -->
         
        <template>
         <div class="row mt-2">
           <!-- Subprogramme -->
           <div class="col-md-4">
             <div class="card mb-3 shadow card-hover">
               <div class="card-body2 d-flex align-items-start">
                 <div class="pt-1">
                   <i class="fas fa-project-diagram fa-2x c64"></i>
                 </div>
                 <div>
                   <h5 class="card-title ml-2">Subprogramme</h5>
                   <p class="card-text mb-0">{{ subprogramTitles() }}</p>
                 </div>
               </div>
             </div>
           </div>
       
           <!-- Project -->
           <div class="col-md-4">
             <div class="card mb-3 shadow card-hover">
               <div class="card-body2 d-flex align-items-start">
                 <div class="pt-1">
                   <i class="fas fa-tasks fa-2x c64"></i>
                 </div>
                 <div>
                   <h5 class="card-title ml-2">Project</h5>
                   <p class="card-text mb-0">{{ projectTitles() }}</p>
                 </div>
               </div>
             </div>
           </div>
       
           <!-- Thematic Area -->
           <div class="col-md-4">
             <div class="card mb-3 shadow card-hover">
               <div class="card-body2 d-flex align-items-start">
                 <div class="pt-1">
                   <i class="fas fa-layer-group fa-2x c64"></i>
                 </div>
                 <div>
                   <h5 class="card-title ml-2">Thematic Area</h5>
                   <p class="card-text mb-0">{{ thematicTitles() }}</p>
                 </div>
               </div>
             </div>
           </div>
       
           <!-- Date Range -->
           <div class="col-md-4">
             <div class="card mb-3 shadow card-hover">
               <div class="card-body2 d-flex align-items-start">
                 <div class="pt-1">
                   <i class="fas fa-calendar-alt fa-2x c64"></i>
                 </div>
                 <div>
                   <h5 class="card-title ml-2">Date Range</h5>
                   <p class="card-text mb-0">{{ startDate }} - {{ endDate }}</p>
                 </div>
               </div>
             </div>
           </div>
       
           <!-- Number of Events -->
           <div class="col-md-4">
             <div class="card mb-3 shadow card-hover cursor-pointer" @click="openModal">
               <div class="card-body2 d-flex align-items-start">
                 <div class="pt-1">
                   <i class="fas fa-chart-bar fa-2x c64"></i>
                 </div>
                 <div>
                   <h5 class="card-title ml-2">Number of Events</h5>
                   <p class="card-text mb-0">{{ trainings.length }}</p>
                 </div>
               </div>
             </div>
           </div>
         </div>
    </template>

         <!-- Gender Segregation and Average Actual Knowledge Change -->
        <div class="row p-lg-3">
            <!-- --------------------------  -->
            <div class="col-lg-4">
                <table class="table table-bordered mb-1">
                    <thead>
                        <tr>
                            <th style="text-align:center">Gender Segregation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="text-align:center">
                                <div id="pie-male-female" style="min-height:170px;height: 170px; width: 100%;margin-bottom:0px"></div>
                                <b>Males: </b>{{ maleCount  }} <b>Females: </b>{{ femaleCount  }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-4 text-center">
                <h6 class="mt-3 text-dark" style="">
                    Average Actual knowledge change
                </h6>
                <div id="average-actual-knowledge-change" style="height: 250px; width: 100%;" class="print-actual-graph"></div>
            </div>
        </div>
        <!-- Graphs -->
        <div class="row ">
            
            <!-- --------------------------  -->
            <div class="col-lg-3 line-bordered text-center" v-for="(question, qindex) in preQuestionsArray" :key="qindex">
                <h6 class="mt-3 text-dark">{{ question.questionTitle }}</h6>

                <!-- Dynamic Chart Container -->
                <div :id="'graph' + qindex" style="height: 300px; width: 100%"></div>
            </div>

        
            <div class="col-lg-3 line-bordered text-center" v-for="(question, qindex) in postQuestionsArray" :key="qindex">
                <h6 class="mt-3 text-dark">{{ question.questionTitle }}</h6>

                <!-- Dynamic Chart Container -->
                <div :id="'graphp' + qindex" style="height: 300px; width: 100%"></div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal2" v-if="isModalOpen">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Events</h4>
                        <button type="button" class="close" @click="closeModal">
                            &times;
                        </button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Events</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in trainings" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.title }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal close -->
    </template>

</div>
</template>

    
<script>
import axios from "axios";
import Selectize from "vue2-selectize";
import 'vue-multiselect/dist/vue-multiselect.min.css';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Highcharts from "../../../public/highcharts";


export default {
    data: () => ({

        selectedArea: null,
        areaId: "",
        thematicReport: [],
        userId: JSON.parse(localStorage.getItem("currentUser")).id,
        userRole: localStorage.getItem("isPermission"),
        BASE_PATH: process.env.VUE_APP_BASE_PATH,
        maleCount: 0,
        femaleCount: 0,
        prePercent: 0,
        postPercent: 0,
        commonQuestions: [],
        questionsPArray: [],
        counterA: 0,
        labelArray: [],
        labelPArray: [],
        selectedOptions: [],
        selectedPOptions: [],
        isModalOpen: false,
        showGraph: false,
        dateRange: [],
        dateOptions: {
            wrap: true,
            weekNumbers: true,
            mode: "range",
            dateFormat: "d-m-Y"
        },
        startDate: '',
        endDate: '',
        subProgramSetting: {
            maxItems: 10,
            searchField: ["text"],
            placeholder: "Select sub program here",
            plugins: ["remove_button"],
        },
        subprogramsArray: [],
        subprogram: [],
        projectSetting: {
            maxItems: 10,
            searchField: ["text"],
            placeholder: "Select project here",
            plugins: ["remove_button"],
        },
        projectsArray: [],
        project: [],
        thematicId: [],
        thematicSetting: {
            maxItems: 10,
            searchField: ["text"],
            placeholder: "Select thematic area here",
            plugins: ["remove_button"],
        },
        thematicAreasLoad: [],
        preQuestionsArray: [],
        postQuestionsArray: [],
        trainings: [],
       
    }),
    mounted() {
        axios.defaults.headers["Authorization"] = localStorage.getItem("token");
        this.openLoading();
        let endpoint = "";
                     switch (this.userRole) {
                         case "admin":
                             endpoint = "/show/thematicArea/get";
                             break;
                         case "advisor":
                             endpoint = `/show/thematicArea/get?advisor_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/show/thematicArea/get?programofficer_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }

        axios
            .get(this.BASE_PATH + endpoint)
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.thematicAreasLoad = response.data;
            });
            let endpoint2 = "";
        switch (this.userRole) {
            case "admin":
                endpoint2 = "/subprograms/get";
                break;
            case "advisor":
                endpoint2 = `/advisor/subprograms/${this.userId}/get`;
                break;
            case "program_officer":
                endpoint2 = `/program_officer/subprograms/${this.userId}/get`;
                break;
            default:
                throw new Error("Invalid user role");
        }
        axios.get(this.BASE_PATH + endpoint2)
            .then((response) => {
                this.subprogramsArray = response.data;
            });

    },
    methods: {
        openModal() {
            console.log(this.trainings);
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },

        // getReport() {
        //     axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        //     this.openLoading();
        //     this.showGraph = true;
        //     axios
        //         .post(process.env.VUE_APP_BASE_PATH + "/report/getTrainingViaThematicId", {
        //             thematicIds: this.thematicId,
        //             startDate: this.startDate,
        //             endDate: this.endDate,
        //             subProgramIds: this.subprogram,
        //             projectIds: this.project
        //         })
        //         .then(response => {
        //             if (response.data == "") {
        //                 this.closeLoading();
        //                 this.$toasted.global.errorMsg('There is no data');
        //             }
        //             if (response.data.unAuth) {
        //                 this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
        //                 localStorage.clear();
        //                 setTimeout(() => {
        //                     this.$router.push("/");
        //                 }, 1000);
        //             }
        //             if (response.data.tokenExpired) {
        //                 this.$toasted.global.errorMsg(response.data.tokenExpired);
        //                 localStorage.clear();
        //                 setTimeout(() => {
        //                     this.$router.push("/");
        //                 }, 1000);
        //             }
        //             this.closeLoading();
        //             this.thematicReport = response.data;
        //             this.maleCount = response.data.genderCounts.maleCount;
        //             this.femaleCount = response.data.genderCounts.femaleCount;
        //             this.prePercent = response.data.knowledgebase.prePercentage;
        //             this.postPercent = response.data.knowledgebase.postPercentage;
        //             this.trainings = response.data.trainings;
        //             this.genderChart();
        //             this.assesmentChart();
        //             this.preQuestionsArray = response.data.standardPreQuestions;
        //             this.showPreQuestions(response.data.standardPreQuestions);
        //             this.postQuestionsArray = response.data.standardPostQuestions;
        //             this.showPostQuestions(response.data.standardPostQuestions);

        //         })

        // },
        getReport() {
            // Check if thematicId is empty
            if (!this.thematicId || this.thematicId.length === 0) {
                this.$toasted.global.errorMsg('Please select thematic area');
                return; // Exit the function early
            }
        
            axios.defaults.headers['Authorization'] = localStorage.getItem('token');
            this.openLoading();
            this.showGraph = true;
            
            axios.post(process.env.VUE_APP_BASE_PATH + "/report/getTrainingViaThematicId", {
                thematicIds: this.thematicId,
                startDate: this.startDate,
                endDate: this.endDate,
                subProgramIds: this.subprogram,
                projectIds: this.project
            })
            .then(response => {
                this.closeLoading();
                
                // Handle empty data
                if (!response.data || response.data === "") {
                    this.$toasted.global.errorMsg('There is no data');
                    return;
                }
                
                // Handle unauthorized cases
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('You are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                
                // Handle token expiration
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                    return;
                }
                
                // Process successful response
                this.thematicReport = response.data;
                this.maleCount = response.data.genderCounts.maleCount;
                this.femaleCount = response.data.genderCounts.femaleCount;
                this.prePercent = response.data.knowledgebase.prePercentage;
                this.postPercent = response.data.knowledgebase.postPercentage;
                this.trainings = response.data.trainings;
                this.genderChart();
                this.assesmentChart();
                this.preQuestionsArray = response.data.standardPreQuestions;
                this.showPreQuestions(response.data.standardPreQuestions);
                this.postQuestionsArray = response.data.standardPostQuestions;
                this.showPostQuestions(response.data.standardPostQuestions);
            })
            .catch(error => {
                this.closeLoading();
                
                // Handle different types of errors
                if (error.response) {
                    // Server responded with error status (4xx, 5xx)
                    const errorMsg = error.response.data.message || 'Failed to get report data';
                    this.$toasted.global.errorMsg(errorMsg);
                } else if (error.request) {
                    // Request was made but no response received
                    this.$toasted.global.errorMsg('Network error - please check your connection');
                } else {
                    // Other errors
                    this.$toasted.global.errorMsg('An error occurred while fetching the report');
                }
            });
        },
        genderChart: function genderChart() {
            Highcharts.chart("pie-male-female", {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie",
                },
                title: {
                    text: "Browser market shares at a specific website, 2014",
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.0f}%</b>",
                },
                accessibility: {
                    point: {
                        valueSuffix: "%",
                    },
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",

                        dataLabels: {
                            enabled: true,
                            format: "<b>{point.name}</b><br>{point.percentage:.0f} %",
                            distance: -35,
                            filter: {
                                property: "percentage",
                                operator: ">",
                                value: 4,
                            },
                        },
                    },
                },
                series: [{
                    name: "Share",
                    data: [{
                            name: "Males",
                            y: this.maleCount,
                            color: "#4774B8"
                        },
                        {
                            name: "Females",
                            y: this.femaleCount,
                            color: "#EA7D3A"
                        },
                    ],
                }, ],
            });
        },
        assesmentChart() {

            Highcharts.chart("average-actual-knowledge-change", {
                chart: {
                    type: "column",
                },
                title: {
                    text: "Browser market shares. January, 2018",
                },

                accessibility: {
                    announceNewData: {
                        enabled: true,
                    },
                },
                xAxis: {
                    type: "category",
                },
                yAxis: {},
                legend: {
                    enabled: false,
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: "{point.y:.1f}%",

                        }
                    },
                },

                tooltip: {

                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
                },

                series: [{

                    colorByPoint: true,
                    data: [{
                            name: "Pre",
                            y: this.prePercent,
                            color: "#80ff80"
                        },
                        {
                            name: "Post",
                            y: this.postPercent,
                            color: "#63b94b",
                        },
                    ],
                }, ],
            });
        },
        showPreQuestions(standardPreQuestions) {

            setTimeout(() => {
                standardPreQuestions.forEach((element, index) => {

                    if (element.label.length == 2) {

                        Highcharts.chart("graph" + index, {
                            chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: "pie",

                            },
                            title: {
                                text: "Browser market shares in January, 2018",
                            },
                            tooltip: {
                                pointFormat: "{series.name}: <b>{point.percentage:.2f}%</b>",
                            },
                            plotOptions: {
                                pie: {
                                    allowPointSelect: true,
                                    cursor: "pointer",
                                    // colors: pieColors,
                                    dataLabels: {
                                        enabled: true,
                                        format: "<b>{point.name}</b><br>{point.percentage:.0f} %",
                                        distance: -35,
                                        filter: {
                                            property: "percentage",
                                            operator: ">",
                                            value: 4,
                                        },
                                    },
                                },
                            },

                            series: [{
                                name: "Answer",
                                colorByPoint: true,
                                data: [{
                                        name: element.label[0],
                                        y: element.Options[0],
                                        color: "#71da71",
                                    },
                                    {
                                        name: element.label[1],
                                        y: element.Options[1],
                                        color: "#ff5c33",
                                    },
                                ],
                            }, ],
                        });
                    } else if (
                        element.label &&
                        element.label.length == 4
                    ) {

                        Highcharts.chart("graph" + index, {
                            chart: {
                                type: "column",
                            },
                            title: {
                                text: "Stacked column chart",
                            },
                            xAxis: {
                                // categories: ["Practicals Testing"],
                            },
                            yAxis: {
                                min: 0,
                                stackLabels: {
                                    enabled: false,
                                    style: {
                                        fontWeight: "bold",
                                        color:
                                            // theme
                                            (Highcharts.defaultOptions.title.style &&
                                                Highcharts.defaultOptions.title.style
                                                .color) ||
                                            "gray",
                                    },
                                },

                            },
                            legend: {
                                align: "center",
                                x: -30,
                                verticalAlign: "bottom",
                                y: 15,
                                floating: false,
                                backgroundColor: Highcharts.defaultOptions.legend
                                    .backgroundColor || "white",
                                borderColor: "#CCC",
                                borderWidth: 1,
                                shadow: false,
                                itemStyle: {
                                    fontSize: '10px',
                                }
                            },
                            tooltip: {
                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                shared: true,
                            },
                            plotOptions: {
                                column: {
                                    stacking: "percent",
                                    dataLabels: {
                                        enabled: true,
                                        formatter: function () {
                                            if (this.y != 0) {
                                                return this.point.percentage.toFixed(1) + '%'
                                            }
                                        },
                                        // enabled:true,
                                        // format:'{point.percentage:.2f} %',
                                    }
                                },
                            },
                            series: [{
                                    name: element.label[0],
                                    data: [element.Options[0]],
                                    color: "#D1324E"

                                },
                                {
                                    name: element.label[1],
                                    data: [element.Options[1]],
                                    color: "#EF522F"

                                },
                                {
                                    name: element.label[2],
                                    data: [element.Options[2]],
                                    color: "#FEC447"
                                },
                                {
                                    name: element.label[3],
                                    data: [element.Options[3]],
                                    color: "#6AAA4A",

                                }

                            ]
                        });

                    } else if (
                        element.label &&
                        element.label.length == 3
                    ) {

                        Highcharts.chart("graph" + index, {
                            chart: {
                                type: "column",
                            },
                            title: {
                                text: "Stacked column chart",
                            },
                            xAxis: {
                                // categories: ["Testing"],
                            },
                            yAxis: {
                                min: 0,
                                stackLabels: {
                                    enabled: false,
                                    style: {
                                        fontWeight: "bold",
                                        color:
                                            // theme
                                            (Highcharts.defaultOptions.title.style &&
                                                Highcharts.defaultOptions.title.style
                                                .color) ||
                                            "gray",
                                    },
                                },
                            },
                            legend: {
                                align: "right",
                                x: -30,
                                verticalAlign: "bottom",
                                y: 15,
                                floating: false,
                                backgroundColor: Highcharts.defaultOptions.legend
                                    .backgroundColor || "white",
                                borderColor: "#CCC",
                                borderWidth: 1,
                                shadow: false,
                                itemStyle: {
                                    fontSize: '10px',

                                }
                            },
                            tooltip: {
                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                                shared: true,
                            },
                            plotOptions: {
                                column: {
                                    stacking: "percent",
                                    dataLabels: {
                                        enabled: true,
                                        // format:'{point.percentage:.2f} %'
                                        formatter: function () {
                                            if (this.y != 0) {
                                                return this.point.percentage.toFixed(1) + '%'
                                            }
                                        },
                                    }
                                },
                            },
                            series: [{
                                    name: element.label[0],
                                    data: [element.Options[0]],
                                    // color: element.label[0] === "To Short" ? "#0099cc" : "#cc0000",
                                    color: "#cc0000"
                                },
                                {
                                    name: element.label[1],
                                    data: [element.Options[1]],
                                    color: "#ffd633",
                                },
                                {
                                    name: element.label[2],
                                    data: [element.Options[2]],
                                    // color: element.label[0] === "Duration is fine" ? "#cc0000" : "#0099cc" ,
                                    color: "#0099cc",

                                },
                            ],
                        });
                    } else if (element.label &&
                        element.label.length == 5) {

                        Highcharts.chart("graph" + index, {
                            chart: {
                                type: "column",
                            },
                            title: {
                                text: "Stacked column chart",
                            },
                            xAxis: {
                                // categories: ["Practicals Testing"],
                            },
                            yAxis: {
                                min: 0,
                                stackLabels: {
                                    enabled: false,
                                    style: {
                                        fontWeight: "bold",
                                        color:
                                            // theme
                                            (Highcharts.defaultOptions.title.style &&
                                                Highcharts.defaultOptions.title.style
                                                .color) ||
                                            "gray",
                                    },
                                },

                            },
                            legend: {
                                align: "center",
                                x: -30,
                                verticalAlign: "bottom",
                                y: 15,
                                floating: false,
                                backgroundColor: Highcharts.defaultOptions.legend
                                    .backgroundColor || "white",
                                borderColor: "#CCC",
                                borderWidth: 1,
                                shadow: false,
                                itemStyle: {
                                    fontSize: '10px',
                                }
                            },
                            tooltip: {
                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                shared: true,
                            },
                            plotOptions: {
                                column: {
                                    stacking: "percent",
                                    dataLabels: {
                                        enabled: true,
                                        formatter: function () {
                                            if (this.y != 0) {
                                                return this.point.percentage.toFixed(1) + '%'
                                            }
                                        },
                                        // enabled:true,
                                        // format:'{point.percentage:.2f} %',
                                    }
                                },
                            },
                            series: [{
                                    name: element.label[0],
                                    data: [element.Options[0]],
                                    color: "#D1324E"

                                },
                                {
                                    name: element.label[1],
                                    data: [element.Options[1]],
                                    color: "#EF522F"

                                },
                                {
                                    name: element.label[2],
                                    data: [element.Options[2]],
                                    color: "#FEC447"
                                },
                                {
                                    name: element.label[3],
                                    data: [element.Options[3]],
                                    color: "#6AAA4A",

                                },
                                {
                                    name: element.label[4],
                                    data: [element.Options[4]],
                                    color: "#218FCE",

                                }
                            ]
                        });
                    }

                });
                this.closeLoading();
            }, 1000);

        },
        showPostQuestions(standardPostQuestions) {
            setTimeout(() => {
                standardPostQuestions.forEach((element, index) => {

                    if (element.label && element.label.length == 2) {

                        Highcharts.chart("graphp" + index, {
                            chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: "pie",
                            },
                            title: {
                                text: "Browser market shares in January, 2018",
                            },
                            tooltip: {
                                pointFormat: "{series.name}: <b>{point.percentage:.2f}%</b>",
                            },
                            plotOptions: {
                                pie: {
                                    allowPointSelect: true,
                                    cursor: "pointer",
                                    dataLabels: {
                                        enabled: false,
                                        formatter: function () {
                                            if (this.y != 0) {
                                                return this.point.percentage.toFixed(1) + '%'
                                            }
                                        },

                                        //  format:'{point.percentage:.2f} %'
                                    },
                                    showInLegend: true,
                                },
                            },
                            series: [{
                                name: "Answer",
                                colorByPoint: true,
                                data: [{
                                        name: element.label[0],
                                        y: element.Options[0],
                                        color: "#604a7b",
                                    },
                                    {
                                        name: element.label[1],
                                        y: element.Options[1],
                                        color: "#558ed5",
                                    },
                                ],
                            }, ],
                        });
                    } else if (
                        element.label &&
                        element.label.length == 4
                    ) {

                        Highcharts.chart("graphp" + index, {
                            chart: {
                                type: "column",
                            },
                            title: {
                                text: "Stacked column chart",
                            },
                            xAxis: {
                                // categories: ["Practicals"],
                            },
                            yAxis: {
                                min: 0,
                                stackLabels: {
                                    enabled: false,
                                    style: {
                                        fontWeight: "bold",
                                        color:
                                            // theme
                                            (Highcharts.defaultOptions.title.style &&
                                                Highcharts.defaultOptions.title.style
                                                .color) ||
                                            "gray",
                                    },
                                },
                            },
                            legend: {
                                align: "right",
                                x: -30,
                                verticalAlign: "bottom",
                                y: 15,
                                floating: false,
                                backgroundColor: Highcharts.defaultOptions.legend
                                    .backgroundColor || "white",
                                borderColor: "#CCC",
                                borderWidth: 1,
                                shadow: false,
                                itemStyle: {
                                    fontSize: '12px',
                                }
                            },
                            tooltip: {
                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                shared: true,
                            },
                            plotOptions: {
                                column: {
                                    stacking: "percent",
                                    dataLabels: {
                                        enabled: true,

                                        formatter: function () {
                                            if (this.y != 0) {
                                                return this.point.percentage.toFixed(1) + '%'
                                            }
                                        },

                                        //  format:'{point.percentage:.2f} %'
                                    },
                                },
                            },
                            series: [{
                                    name: element.label[0],
                                    data: [element.Options[0]],
                                    color: "#D1324E"
                                },
                                {
                                    name: element.label[1],
                                    data: [element.Options[1]],
                                    color: "#EF522F"
                                },
                                {
                                    name: element.label[2],
                                    data: [element.Options[2]],
                                    color: "#FEC447"
                                },
                                {
                                    name: element.label[3],
                                    data: [element.Options[3]],
                                    color: "#6AAA4A",

                                }

                            ],
                        });
                    } else if (
                        element.label &&
                        element.label.length == 3
                    ) {

                        Highcharts.chart("graphp" + index, {
                            chart: {
                                type: "column",
                            },
                            title: {
                                text: "Stacked column chart",
                            },
                            xAxis: {
                                // categories: ["Practicals"],
                            },
                            yAxis: {
                                min: 0,
                                stackLabels: {
                                    enabled: false,
                                    style: {
                                        fontWeight: "bold",
                                        color:
                                            // theme
                                            (Highcharts.defaultOptions.title.style &&
                                                Highcharts.defaultOptions.title.style
                                                .color) ||
                                            "gray",
                                    },
                                },
                            },
                            legend: {
                                // align: "left",
                                // x: -30,
                                verticalAlign: "bottom",
                                // y: 15,
                                floating: false,
                                backgroundColor: Highcharts.defaultOptions.legend
                                    .backgroundColor || "white",
                                borderColor: "#CCC",
                                borderWidth: 1,
                                shadow: false,
                                itemStyle: {
                                    fontSize: '7px',
                                    fontWeight: '1000',
                                },
                            },
                            tooltip: {
                                pointFormat: '<span class="inline" style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                shared: true,
                            },
                            plotOptions: {

                                column: {
                                    stacking: "percent",
                                    dataLabels: {
                                        enabled: true,
                                        formatter: function () {
                                            if (this.y != 0) {
                                                return this.point.percentage.toFixed(1) + '%'
                                            }
                                        },

                                        //  format:'{point.percentage:.1f} %'
                                    },
                                },
                            },
                            series: [{
                                    name: element.label[0],
                                    data: [element.Options[0]],
                                    // color: "#71da71",
                                    color: element.label[0] == "Too Short" ? "#D1324E" : "#71da71",

                                },
                                {
                                    name: element.label[1],
                                    data: [element.Options[1]],
                                    color: "#fec447",

                                },
                                {

                                    name: element.label[2],
                                    data: [element.Options[2]],
                                    //  color: "#D1324E",
                                    color: element.label[2] == "Duration is fine" ? "#71da71" : "#D1324E"

                                }

                            ]
                        });
                    } else if (element.label &&
                        element.label.length == 5) {

                        Highcharts.chart("graphp" + index, {
                            chart: {
                                type: "column",
                            },
                            title: {
                                text: "Stacked column chart",
                            },
                            xAxis: {
                                // categories: ["Practicals"],
                            },
                            yAxis: {
                                min: 0,
                                stackLabels: {
                                    enabled: false,
                                    style: {
                                        fontWeight: "bold",
                                        color:
                                            // theme
                                            (Highcharts.defaultOptions.title.style &&
                                                Highcharts.defaultOptions.title.style
                                                .color) ||
                                            "gray",
                                    },
                                },
                            },
                            legend: {
                                align: "right",
                                x: -30,
                                verticalAlign: "bottom",
                                y: 15,
                                floating: false,
                                backgroundColor: Highcharts.defaultOptions.legend
                                    .backgroundColor || "white",
                                borderColor: "#CCC",
                                borderWidth: 1,
                                shadow: false,
                                itemStyle: {
                                    fontSize: '12px',
                                }
                            },
                            tooltip: {
                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                shared: true,
                            },
                            plotOptions: {
                                column: {
                                    stacking: "percent",
                                    dataLabels: {
                                        enabled: true,

                                        formatter: function () {
                                            if (this.y != 0) {
                                                return this.point.percentage.toFixed(1) + '%'
                                            }
                                        },

                                        //  format:'{point.percentage:.2f} %'
                                    },
                                },
                            },
                            series: [{
                                    name: element.label[0],
                                    data: [element.Options[0]],
                                    color: "#D1324E"
                                },
                                {
                                    name: element.label[1],
                                    data: [element.Options[1]],
                                    color: "#EF522F"
                                },
                                {
                                    name: element.label[2],
                                    data: [element.Options[2]],
                                    color: "#FEC447"
                                },
                                {
                                    name: element.label[3],
                                    data: [element.Options[3]],
                                    color: "#6AAA4A",

                                },
                                {
                                    name: element.label[4],
                                    data: [element.Options[4]],
                                    color: "#218FCE",

                                },
                            ],
                        });
                    }

                })

                this.closeLoading();
            }, 1000);
        },
        PrintEvent() {
            window.print();
        },
        showProjects() {
            this.openLoading();
            axios.post(process.env.VUE_APP_BASE_PATH + "/projects/get/multi-show", {
                    subProgramIds: this.subprogram
                })
                .then((response) => {
                    this.closeLoading();
                    this.projectsArray = response.data;
                });
        },
        subprogramTitles() {
            return this.subprogram
                .map(id =>
                    this.subprogramsArray.find(item => item.id == Number(id))
                )
                .filter(item => item) // remove null/undefined if id not found
                .map(item => item.title)
                .join(', ');
        },
        thematicTitles() {

            return this.thematicId
                .map(id =>
                    this.thematicAreasLoad.find(item => item.id == Number(id))
                )
                .filter(item => item) // remove null/undefined if id not found
                .map(item => item.name)
                .join(', ');
        },
        projectTitles() {
            return this.project
                .map(id =>
                    this.projectsArray.find(item => item.id == Number(id))
                )
                .filter(item => item) // remove null/undefined if id not found    
                .map(item => item.title)
                .join(', ');
        }

    },

    components: {
        flatPickr,
        Selectize
    },
    watch: {
        selectedArea(newValue) {
            this.areaId = newValue.id
        },
        dateRange(date) {
            this.startDate = date.split("to")[0].trim();
            this.endDate = date.split("to")[1].trim();
        },
        subprogram(val) {
            if (val != '') {
                this.showProjects();
            }

        }
    },

};
</script>

    
<style scoped>

.btn-report {
    background-color: #6488d2 !important;
    border-radius: 5px !important;
    padding: 5px 20px !important;
    margin-right: 10px;
    margin-top: 10px;
}

.pointer-cursor {
    cursor: pointer;
}

.modal2 {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
   
}

/* Modal content */
.modal-content {
    background-color: #fefefe;
    margin: 1% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 100%;
}

.modal-dialog {
    max-width: 600px
}

/* Close button */
.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
.print-title {
        padding-left: 18px;
        padding-top: 10px;
        font-size: 20px;
    }
    .line-bordered {
    border-top: 1px solid #6c757d;
    border-bottom: 1px solid #6c757d;
    border-left: 1px solid #6c757d;
    border-right: 1px solid #6c757d;
}
@media print {
    /* Basic print setup */
    body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* Page break control */
    .row {
        page-break-inside: avoid;
        break-inside: avoid;
    }

    .line-bordered {
        page-break-inside: avoid;
        break-inside: avoid;
    }

    /* Force page breaks where needed */
    .row.p-lg-3 {
        page-break-before: auto;
        break-before: auto;
    }

    /* Ensure content visibility */
    .print_logo {
        display: block !important;
    }

    .print-media {
        display: none;
    }

    .btn-report {
        display: none;
    }

    /* Column sizing for print */
    .col-lg-4 {
        flex: 1;
        max-width: 50%;
    }
    .col-md-4{
        
        max-width: 50%;
    }
    .col-lg-3 {
        flex: 1;
        max-width: 33.33%;
    }

    /* Ensure charts are visible and properly sized */
    canvas {
        max-width: 100% !important;
        height: auto !important;
    }

    /* Ensure text is visible */
    .text-blue,
    .text-dark {
        color: #000 !important;
    }

    /* Remove backgrounds and shadows */
    .report-summary-container {
        box-shadow: none !important;
        background: none !important;
    }

    /* Ensure proper spacing */
    .mt-3,
    .mt-6 {
        margin-top: 1rem !important;
    }

    /* Ensure tables don't break */
    table {
        page-break-inside: avoid;
        break-inside: avoid;
    }
}

.report-summary-container {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
}

.summary-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #e9ecef;
}

.summary-item:last-child {
    border-bottom: none;
}

.summary-item:hover {
    background-color: #f8f9fa;
}

.summary-item.clickable {
    cursor: pointer;
}

.summary-label {
    flex: 0 0 200px;
    display: flex;
    align-items: center;
    color: #2c3e50;
    font-weight: 700;
    font-size: 1.1rem;
}

.summary-label i {
    width: 24px;
    margin-right: 0.75rem;
    color: #6488d2;
}

.summary-value {
    flex: 1;
    color: #2c3e50;
    font-weight: 500;
    text-align: left;
    padding-left: 1rem;
    font-size: 1rem;
}

@media (max-width: 768px) {
    .summary-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .summary-label {
        flex: 0 0 auto;
        margin-bottom: 0.5rem;
    }

    .summary-value {
        text-align: left;
        padding-left: 2.5rem;
    }
}
/* Cards */
.card-body2{
    padding: 10px;
    height: 130px;
    overflow-y: auto;
}
.c64{
    color: #6488d2 !important;
}
.cursor-pointer{
    cursor: pointer;
}

.card-hover {
  transition: transform 0.2s, box-shadow 0.2s;
  border-radius: 8px;
}

.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.1);
}


</style>
